import { render, staticRenderFns } from "./orderPage.vue?vue&type=template&id=3ac9e66e&"
import script from "./orderPage.vue?vue&type=script&lang=js&"
export * from "./orderPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports